/* unplugin-vue-components disabled */// extracted by css-extract-rspack-plugin
export default {"container":"sandbox_container__qwyOQ"};